// extracted by mini-css-extract-plugin
export default {"gglogo":"FamilyClinicNavbar_gglogo__HQsXj","toolpbar":"FamilyClinicNavbar_toolpbar__Iu+om"};